/**
 *  * Категория
 * Подкатегория
 * Тип
 * Серийник
 * Наименование
 * Сотрудник
 * user
 * worker
 * Срок годности
 * Файлы
 */

import { wordForm } from "@/utils/text/wordForm";
import { toDate } from "@/utils/date/to-date";
import { ACTION_ISSUE, ACTION_WRITEOFF, ACTION_TRANSFER } from "../constants";

const now = new Date();

function isExpired(expiredDate) {
    if (!expiredDate) return false;

    const date = toDate(expiredDate, "client");
    return +now > +date;
}

function getItemDataStatus(action) {
    let isWrittenOff = false;
    let isIssued = false;
    let workerId = null;
    let workerName = "";
    const holder = action && action.inventory && action.inventory.holder || '';
    const holderId = action && action.inventory && action.inventory.holder_id || '';
    const issueDate = action && action.inventory && action.inventory.issue_date || '';

    if (action) {
        const { action: actionType, worker: actionWorker } = action;
        if (actionType && actionType.toString() === ACTION_ISSUE) {
            isIssued = true;
            if (actionWorker) {
                workerId = actionWorker.id;
                workerName = actionWorker.name;
            }
        } else if (actionType && actionType.toString() === ACTION_WRITEOFF) {
            isWrittenOff = true;
        } else if (actionType && actionType.toString() === ACTION_TRANSFER) {
            isIssued = true;

            const { recipientWorker: recipient } = action;

            if (recipient) {
                workerId = recipient.id;
                workerName = recipient.name;
            }
        }
    }

    return {
        isWrittenOff,
        isIssued,
        workerId,
        workerName,
        holder,
        issueDate,
        holderId
    };
}

function getItemData(data) {
    const {
        id,
        category,
        subcategory,
        type,
        name,
        guid,
        exp_date,
        cost,
        manuf_date,
        model,
        purch_date,
        purch_place,
        inventoryFiles,
        issue_date,
        holder,
        holder_id,
    } = data;

    const expirationDate = exp_date;
    const files = inventoryFiles || [];

    return {
        id,
        category,
        subcategory,
        type,
        name,
        serialNumber: guid,
        expirationDate,
        cost: parseInt(cost, 10) || 0,
        productionDate: manuf_date,
        purchaseDate: purch_date,
        purchasePlace: purch_place,
        model,

        files: files.map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        filesLabel: files.length ? `${files.length} ${wordForm(files.length, ["файл", "файла", "файлов"])}` : "",

        isExpired: isExpired(expirationDate),
        issueDate: issue_date,
        holder,
        holderId: holder_id,
    };
}

export function ListItemModel(data) {
    const { inventoryHistories } = data;

    let lastAction = null;
    if (inventoryHistories && inventoryHistories.length) {
        lastAction = [...inventoryHistories].pop();
    }

    return {
        ...getItemData(data),
        ...getItemDataStatus(lastAction),
    };
}

export function updateListItemModel(item, data) {
    const updatedData = getItemData(data);

    Object.entries(updatedData).forEach(([key, value]) => {
        item[key] = value;
    });
}

export function updateListItemStatus(item, data) {
    const updatedData = getItemDataStatus(data);
    Object.entries(updatedData).forEach(([key, value]) => {
        item[key] = value;
    });
}
